module.exports = __webpack_public_path__ + "img/permit2.37417935.png";